export const aupFeedbackCollectorEntrypointId = '1a3369da-be17-4f4d-9c11-bb2895beebc2';
